import React from "react";
import { Pagination } from "antd";
import { ReactComponent as Arrow } from "../../svgs/carrot.svg";
import "./styles.css";

const itemRender = (current, type, originalElement) => {
  if (type === "prev") {
    return (
      <div className="flex flex-grow text-sm gap-x-2 py-2 font-bold font-spaceGrotesk bg-blue-300 rounded-lg px-4 justify-center items-center hover:text-blue-800">
        <Arrow className="h-4 w-4 rotate-90" /> Previous Page
      </div>
    );
  }
  if (type === "next") {
    return (
      <div className="flex text-sm gap-x-2 font-spaceGrotesk py-2 font-bold bg-blue-300 rounded-lg px-4 justify-center items-center hover:text-blue-800">
        Next Page
        <Arrow className="h-4 w-4 -rotate-90" />
      </div>
    );
  }

  if (type === "page") {
    return (
      <div className="text-xs font-normal font-spaceGrotesk px-2 flex justify-center items-center h-full">
        {current}
      </div>
    );
  }

  return originalElement;
};

const index = ({ current, total, pageSize, setCurrentPage, className }) => {
  return (
    <div className="w-full offset-pagination">
      <Pagination
        className={`flex justify-between ${className}`}
        total={total}
        current={current}
        pageSize={pageSize}
        onChange={(page) => {
          setCurrentPage(page);
        }}
        showSizeChanger={false}
        itemRender={itemRender}
        showQuickJumper={false}
      />
    </div>
  );
};

export default index;
